<form
  class="grid"
  style="--bs-columns: 11; --bs-gap: 0"
  [formGroup]="twoFactorCodeForm"
  (paste)="onPaste($event)">
  <ng-container formArrayName="code">
    <div class="g-col-5">
      <div
        class="grid"
        style="--bs-columns: 3; --bs-gap: 10px">
        @for (input of code.controls | slice: 0 : 3; track $index) {
          <div class="g-col">
            <bn-web-ui-input
              #input
              align="center"
              autocompleteInputValue="one-time-code"
              inputmode="numeric"
              type="number"
              [autofocus]="autofocus && $index === 0"
              [formControlName]="$index"
              [hideErrorClass]="true"
              [hideErrorMessages]="true"
              [maxlength]="1"
              [options]="{
                removePadding: true,
                hideRequiredLabel: true,
                hideNumericArrows: true,
                maxSquare: true,
              }"
              [readonly]="loading"
              (input)="onInput($event, $index)"
              (keydown.ArrowLeft)="focusPrev($index)"
              (keydown.ArrowRight)="focusNext($index)"
              (keydown.backspace)="onBackspace($event, $index)"
              (paste)="onInputPaste()" />
          </div>
        }
      </div>
    </div>
    <div class="g-col">
      <div class="bn-two-factor-code__input-splitter">-</div>
    </div>
    <div class="g-col-5">
      <div
        class="grid"
        style="--bs-columns: 3; --bs-gap: 10px">
        @for (input of code.controls | slice: 3 : 6; track $index) {
          <div class="g-col">
            <bn-web-ui-input
              #input
              align="center"
              autocompleteInputValue="one-time-code"
              inputmode="numeric"
              type="number"
              [formControlName]="$index + 3"
              [hideErrorClass]="true"
              [hideErrorMessages]="true"
              [maxlength]="1"
              [options]="{
                removePadding: true,
                hideRequiredLabel: true,
                hideNumericArrows: true,
                maxSquare: true,
              }"
              [readonly]="loading"
              (input)="onInput($event, $index + 3)"
              (keydown.ArrowLeft)="focusPrev($index + 3)"
              (keydown.ArrowRight)="focusNext($index + 3)"
              (keydown.backspace)="onBackspace($event, $index + 3)"
              (paste)="onInputPaste()" />
          </div>
        }
      </div>
    </div>
  </ng-container>
</form>
